// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from "he";

// HOOKS
import { useGetAgencyDetails } from "../../../hooks/useGetAgencyDetails";
import { useGetPolicyUrls } from "../../../hooks/useGetPolicyUrls";

// COMPONENTI
import SubHeaderDefault from "../../Header/subHeader/SubHeaderDefault";
import LoadingIndicator from "../../Loaders/LoadingIndicator";
import NotFound from "../../Error/NotFound";

// STILI
import '../../../assets/styles/PolicyStyles.css';

interface PrivacyProps {
    agencyId: number;
    policy: number;
    isPrivacy: boolean;
}

const Privacy: React.FC<PrivacyProps> = ({ agencyId, policy, isPrivacy }) => {
    const { t } = useTranslation()

    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);
    const { policyHTML, loading: policyLoading, error: policyError } = useGetPolicyUrls(policy, isPrivacy);

    // --- Gestione Loading / Errore ---
    if (agencyLoading || policyLoading) {
        return <LoadingIndicator />;
    }

    if (agencyError || policyError) {
        console.error("Errore caricamento dati Privacy page:", agencyError || policyError);
        return <NotFound message={t('validation.policyLoadError') ?? "Errore durante il caricamento del contenuto della policy."} />;
    }

    if (!agency) {
        return <NotFound message={t('common.agencyNotFound') ?? "Agenzia non trovata"} />;
    }

    if (!policy || typeof policy !== 'number') {
        console.error("Invalid or missing 'policy' prop (Iubenda ID) for Privacy page.");
        return <NotFound message={t('validation.policyConfigError') ?? "Errore nella configurazione della policy."} />;
    }

    // --- Preparazione Testi Tradotti ---
    const agencyName = agency?.agencyName ?? t('common.defaultAgencyName');
    const pageTitle = t('privacyPolicy.title');
    const helmetTitle = t('common.pageTitlePattern', { pageTitle: pageTitle, agencyName: he.decode(`${agencyName}`) });

    return (
        <>
            <Helmet>
                <title>{he.decode(`${helmetTitle}`)}</title>
            </Helmet>

            <SubHeaderDefault title={pageTitle ?? 'Privacy Policy'} isSeo={true} />

            <section className="container space-ptb">

                {policyHTML ? (
                    <div className="policy-content-wrapper" dangerouslySetInnerHTML={{ __html: policyHTML }} />
                ) : (
                    <p>{t('validation:policyLoadError')}</p>
                )}

            </section>
        </>
    );
};

export default Privacy;